import { Navigate, RouteProps, useLocation } from 'react-router-dom';

import React from 'react';
import { hasToken } from 'store/config/selectors';
import { useCurrentUser } from 'hooks/use-current-user.hook';
import { useSelector } from 'react-redux';
import { Skeleton } from 'components/skeleton';
import { ResourceSkeleton } from 'components/resource-skeleton';

interface PrivateProps extends RouteProps {
  redirectTo?: string;
  children: React.ReactNode;
}
export const PrivateRoute: React.FC<PrivateProps> = ({
  redirectTo = '/',
  ...routeProps
}: PrivateProps): JSX.Element | null => {
  const { pathname } = useLocation();
  const isResourcePage = pathname.startsWith('/resource-booking/resource/');
  const [currentUser, loading] = useCurrentUser();
  const isTokenStored = useSelector(hasToken);

  if (currentUser) {
    return <>{routeProps.children}</>;
  }

  if (!isTokenStored && !loading) {
    return <Navigate to={redirectTo} />;
  }

  return isResourcePage ? <ResourceSkeleton /> : <Skeleton />;
};
